
import { EMPTY_INTERFACE_MONITORING_ENTITY, InterfaceMonitoringEntity } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringEntity";
import { EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA, InterfaceMonitoringSearchCriteria } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringSearchCriteria";
import { InterfaceMonitoringRepository } from "domain/repository/InterfaceMonitoring/InterfaceMonitoringRepo";
import _ from "lodash";
import { InterfaceMonitoringStatusDroOpts } from "presentation/constant/DropDownOptions/Document/InterfaceMonitoringStatusDroOpts";
import { BankInterfaceMonitoringMaintenanceModel } from "presentation/model/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceModel";
import { DropdownProps } from "presentation/model/DropdownProps";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface BankInterfaceMonitoringMaintenanceVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<BankInterfaceMonitoringMaintenanceModel>> | ((value: SetStateAction<BankInterfaceMonitoringMaintenanceModel>) => void),
    ],
    repo: InterfaceMonitoringRepository,
}

export const BankInterfaceMonitoringMaintenanceVM = ({ dispatch, repo }: BankInterfaceMonitoringMaintenanceVMProps) => {
    const [bankInterfaceMonitoringDispatch] = dispatch;

    const onSearch = async (searchCriteria: InterfaceMonitoringSearchCriteria) => {
        searchCriteria = {
            ...searchCriteria,
            type: 'bank'
        }
        bankInterfaceMonitoringDispatch(prevState => {
            return {
                ...prevState,
                isShowRightPanel: false,
                // bankInterfaceMonitoringEtys: [],
                selectedBankInterfaceMonitoringRows: [],
                searchCriteria: { ...searchCriteria },
            }
        })
        return await repo.searchInterfaceMonitoringDetail(searchCriteria).then((data) => {
            bankInterfaceMonitoringDispatch(prevState => {
                return {
                    ...prevState,
                    bankInterfaceMonitoringEtys: data,
                }
            })
        }).catch((error) => {
            return [];
        })
    }

    const onResendAll = async (selectedRows: InterfaceMonitoringEntity[]) => {
        return await repo.onResendAll(selectedRows).then((data) => {
            if (data) {

            } else {
                throw new Error(data as string)
            }
            return data;
        })
    }

    const onResend = async (selectedRow: InterfaceMonitoringEntity) => {
        return await repo.onBankResend(selectedRow);
    }

    const onCancel = () => {
        bankInterfaceMonitoringDispatch(prevState => {
            return {
                ...prevState,
                currentBankInterfaceMonitoringEty: EMPTY_INTERFACE_MONITORING_ENTITY,
                isShowRightPanel: false,
                viewState: {
                    ...prevState.viewState,
                    isAdd: false,
                    isEditable: false,
                    isSliderOpen: false,
                    allowAutoRefresh: false,
                    allFormState: {},
                }
            }
        })
    }

    const loadDropdownOption = async () => {

        await repo.searchInterfaceTypeCombobox("BANK").then(typeList => {
            const fromDropdownOptions: DropdownProps[] = [];
            const toDropdownOptions: DropdownProps[] = [];
            const messageTypeDropdownOptions: DropdownProps[] = [];
            typeList?.forEach(type => {
                const fromExisted = fromDropdownOptions?.find(from =>
                    from.value === type.from);
                const toExisted = toDropdownOptions?.find(to =>
                    to.value === type.to);
                const messageTypeExisted = messageTypeDropdownOptions?.find(messageType =>
                    messageType.value === type.messageType);

                if (!fromExisted) {
                    fromDropdownOptions.push({
                        dropdownLabel: type.from,
                        tagLabel: type.from,
                        value: type.from
                    })
                }
                if (!toExisted) {
                    toDropdownOptions.push({
                        dropdownLabel: type.to,
                        tagLabel: type.to,
                        value: type.to
                    })
                }
                if (!messageTypeExisted) {
                    messageTypeDropdownOptions.push({
                        dropdownLabel: type.messageType,
                        tagLabel: type.messageType,
                        value: type.messageType
                    })
                }
            });

            bankInterfaceMonitoringDispatch(prevState => ({
                ...prevState,
                dynamicOptions: {
                    ...prevState.dynamicOptions,
                    messageTypeDropdownOptions: [...messageTypeDropdownOptions],
                    formDropdownOptions: [...fromDropdownOptions],
                    toDropdownOptions: [...toDropdownOptions].reverse()
                }
            }))
        })


        bankInterfaceMonitoringDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                statusDropdownOptions: InterfaceMonitoringStatusDroOpts().getAllInvSendingStatusModel()
            }
        }))

    }

    const onSearchClick = async () => {
        bankInterfaceMonitoringDispatch(prevState => {
            return {
                ...prevState,
                isShowSearchPanel: !prevState.isShowSearchPanel
            }
        });
    }

    const onRemoveAllSearchCriteria = () => {
        bankInterfaceMonitoringDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: { ...EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA }
            }
        })
    }

    const onSearchFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;

        bankInterfaceMonitoringDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: val,
                },
            }
        })
    }

    const onFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        bankInterfaceMonitoringDispatch(prevState => ({
            ...prevState,
            currentBankInterfaceMonitoringEty: {
                ...prevState.currentBankInterfaceMonitoringEty,
                [fieldKey]: val
            }
        }))
    }

    const onSelectedInterfaceMonitorings = (selectedRows: InterfaceMonitoringEntity[]) => {
        bankInterfaceMonitoringDispatch(prevState => {
            return {
                ...prevState,
                selectedBankInterfaceMonitoringRows: selectedRows,
                currentBankInterfaceMonitoringEty: (selectedRows.length === 1 ? selectedRows[0] : EMPTY_INTERFACE_MONITORING_ENTITY),
                isShowRightPanel: (selectedRows.length === 1 ? true : false),
                viewState: {
                    ...prevState.viewState,
                    isEditable: false,
                    isAdd: false
                }
            }
        })
    }

    const onDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        bankInterfaceMonitoringDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            }
        }))
    }

    const setIsSearchLoading = (isSearchLoading: boolean) => {
        bankInterfaceMonitoringDispatch(prevState => {
            return {
                ...prevState,
                isSearchLoading: isSearchLoading,
            }
        })
    }

    return {
        onDateRangeChange: onDateRangeChange,
        loadDropdownOption: loadDropdownOption,
        onResendAll: onResendAll,
        onResend: onResend,
        onCancel: onCancel,
        onSearch: onSearch,
        onSearchClick: onSearchClick,
        onRemoveAllSearchCriteria: onRemoveAllSearchCriteria,
        onSearchFieldChange: onSearchFieldChange,
        onFieldChange: onFieldChange,
        onSelectedInterfaceMonitorings: onSelectedInterfaceMonitorings,
        setIsSearchLoading: setIsSearchLoading,
    }
}